


























import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import config from "../config";

@Component
export default class WorkRequestDeleteItem extends Vue {
  @Prop({ default: "" }) item!: any;
  @Prop({ default: null }) list!: any;

  public async remove(): Promise<void> {
    await axios({
      method: 'DELETE',
      url: config.apiEndpoint + `WorkRequests/${this.item.workRequestId}`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });
    this.$bvModal.hide('WorkRequestModalDelete-' + this.item.ID);
    this.$emit('fetchWorkRequests');
  }
}
